import React from 'react';

const Footer = () => (
  <footer className="py-12 md:py-16 bg-black border-t border-cyan-300/10">
    <div className="container mx-auto px-4 sm:px-6">
      
      <div className="flex flex-col md:flex-row justify-between items-center text-blue-100/60 text-sm">
        <div className="mb-4 md:mb-0">
          &copy; 2025 Nivritti. All rights reserved.
        </div>
        <div className="flex space-x-6">
          <a href='https://paytring.com' target='_blank' className="hover:text-cyan-300 transition-colors">Powered by Paytring</a>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
